// ReSharper disable InconsistentNaming

export enum HashType {
    MD5,
    SHA1,
    SHA224,
    SHA256,
    SHA384,
    SHA512,
}

// ReSharper restore InconsistentNaming
